// mesh-repair.js — Self-Heal DNA module (Agent Zero upgrade)
// Auto-repairs when the anomaly threshold (3) is breached; escalates only after 3 failed repairs.

export const ANOMALY_THRESHOLD = 3;
export const MAX_REPAIR_ATTEMPTS = 3;

export function createSelfHeal(simId, witness) {
  let repairAttempts = 0;

  return {
    simId,
    module: 'Self-Heal',
    check: async () => {
      if (witness.anomalies() < ANOMALY_THRESHOLD) return { healed: false, needed: false };
      repairAttempts += 1;
      if (repairAttempts > MAX_REPAIR_ATTEMPTS) {
        await witness.emit(`ESCALATION: ${MAX_REPAIR_ATTEMPTS} repair attempts failed — requesting Architect attention`, 'anomaly');
        return { healed: false, needed: true, escalated: true };
      }
      witness.resetAnomalies();
      await witness.emit(`Self-repair #${repairAttempts} complete — anomaly counter reset`, 'repair');
      return { healed: true, needed: true, attempt: repairAttempts };
    },
    markStable: () => { repairAttempts = 0; },
  };
}
